export default __webpack_public_path__ + "static/media/wall.svg";